import { Button, DataSource, Label, Layout, Switch, Table } from "@mcleod/components";

export abstract class AutogenLayoutModelVersions extends Layout {
    buttonOpenBaseVersion: Button;
    labelBaseVersion: Label;
    sourceCustomModelDefinition: DataSource;
    switchBaseVersionActive: Switch;
    tableVersions: Table;
}
